import { ref, defineAsyncComponent, type Ref } from 'vue';
import { useSlideout } from '~/composables/utils/useSlideout';
import type { DeliveryMethodType, BigTicketDeliveryMethod } from '~/modules/white-glove/constants/deliveryOptions';

const WhiteGloveDeliverySlideoutContent = defineAsyncComponent(
  () => import('~/modules/white-glove/components/slideout/WhiteGloveDeliverySlideoutContent.vue'),
);
const WhiteGloveDeliverySlideoutFooter = defineAsyncComponent(
  () => import('~/modules/white-glove/components/slideout/WhiteGloveDeliverySlideoutFooter.vue'),
);

function getInitialDeliveryType(deliveryMethods: BigTicketDeliveryMethod[], currentSelection: string | null): DeliveryMethodType {
  return deliveryMethods.some((method) => method.type === currentSelection)
    ? (currentSelection as DeliveryMethodType)
    : (deliveryMethods[0]!.type as DeliveryMethodType);
}

export default function useWhiteGloveDeliverySlideout(modelValue: Ref<string | null>) {
  const { showSlideout, closeSlideout } = useSlideout();

  function openSlideout(deliveryMethods: BigTicketDeliveryMethod[]) {
    const selectedDeliveryType = ref(getInitialDeliveryType(deliveryMethods, modelValue.value));

    showSlideout({
      id: 'white-glove-delivery-slideout',
      title: 'Scheduled Delivery Method',
      backable: false,
      component: WhiteGloveDeliverySlideoutContent,
      footerComponent: WhiteGloveDeliverySlideoutFooter,
      props: {
        modelValue: selectedDeliveryType.value,
        deliveryMethods,
      },
      evtHandlers: {
        'update:modelValue': (value: DeliveryMethodType) => {
          selectedDeliveryType.value = value;
        },
      } as Record<string, (...args: unknown[]) => void>,
      footerEvtHandlers: {
        cancel: closeSlideout,
        save: () => {
          modelValue.value = selectedDeliveryType.value;
          closeSlideout();
        },
      },
    });
  }

  return { openSlideout };
}
